<template>
    <Layout>
        <PageHeader :items="items" :title="title"/>
        <loader :active="loading"/>
        <div class="checkout-tabs">
            <b-tabs pills vertical nav-class="p-0" nav-wrapper-class="col-lg-2 w-100">
                <b-tab v-for="(section, sectionName, index) in faqData" :key="sectionName" :active="index === 0">
                    <template v-slot:title>
                        <i class="d-block check-nav-icon mt-4 mb-2" :class="[section.icon ? section.icon : 'fa fa-question']"></i>
                        <p class="font-weight-bold mb-4">{{sectionName }}</p>
                    </template>
                    <b-card-text>
                        <div class="card">
                            <div class="card-body">
                                <div class="tab-pane fade show active">
                                    <h4 class="card-title mb-5" v-html="sectionName"></h4>
                                    <div v-for="(answer, question) in section.questions" :key="question" class="faq-box media mb-4">
                                        <div class="faq-icon mr-3">
                                            <i class="bx bx-help-circle font-size-20 text-success"></i>
                                        </div>
                                        <div class="media-body">
                                            <h5 class="font-size-15" v-html="question"></h5>
                                            <p class="text-muted" v-html="answer"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- end card-body -->
                        </div>
                        <!-- end card -->
                    </b-card-text>
                </b-tab>
            </b-tabs>
        </div>
    </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

/**
 * Starter component
 */
export default {
    name: "Faq",
    components: {Layout, PageHeader},
    data() {
        return {
            title: "FAQ",
            items: [
                {
                    text: "Serwer",
                    href: "/"
                },
                {
                    text: "FAQ",
                    active: true
                }
            ],
            loading: true
        };
    },
    computed: {
        faqData() {
            return this.$store.getters['cfg/get'].panel.faq.content;
        }
    },
    mounted() {
        this.loading = false;
    }
};
</script>